// Block types enum for email editor
export const BLOCK_TYPES = {
  HEADER: 'header',
  TEXT: 'text',
  IMAGE: 'image',
  BUTTON: 'button',
  CONTAINER: 'container',
  DIVIDER: 'divider',
  SPACER: 'spacer',
  COLUMNCONTAINER: 'columncontainer',
  COLUMN: 'column', // New block type for columns
  HTMLCONTENT: 'htmlcontent' // New block type for HTML content
};

// Block type labels for UI display
export const BLOCK_TYPE_LABELS = {
  [BLOCK_TYPES.HEADER]: 'Header',
  [BLOCK_TYPES.TEXT]: 'Text',
  [BLOCK_TYPES.IMAGE]: 'Image',
  [BLOCK_TYPES.BUTTON]: 'Button',
  [BLOCK_TYPES.CONTAINER]: 'Container',
  [BLOCK_TYPES.COLUMNCONTAINER]: 'Column Container',
  [BLOCK_TYPES.DIVIDER]: 'Divider',
  [BLOCK_TYPES.SPACER]: 'Spacer',
  [BLOCK_TYPES.COLUMN]: 'Column', // Label for column block type
  [BLOCK_TYPES.HTMLCONTENT]: 'HTML Content' // Label for HTML content block type

};

// Block type descriptions for tooltips/help text
export const BLOCK_TYPE_DESCRIPTIONS = {
  [BLOCK_TYPES.HEADER]: 'Create a header with customizable styles',
  [BLOCK_TYPES.TEXT]: 'Add text content with formatting options',
  [BLOCK_TYPES.IMAGE]: 'Insert images with responsive sizing',
  [BLOCK_TYPES.BUTTON]: 'Create clickable call-to-action buttons',
  [BLOCK_TYPES.CONTAINER]: 'Group other blocks together with layout options',
  [BLOCK_TYPES.COLUMNCONTAINER]: 'Group columns together with layout options',
  [BLOCK_TYPES.DIVIDER]: 'Add horizontal lines to separate content',
  [BLOCK_TYPES.SPACER]: 'Add vertical spacing between elements',
  [BLOCK_TYPES.COLUMN]: 'Create columns for responsive layouts',
  [BLOCK_TYPES.HTMLCONTENT]: 'Embed custom HTML content' // Description for HTML content block type
};

// Block type icons (for Material-UI icons)
export const BLOCK_TYPE_ICONS = {
    [BLOCK_TYPES.HEADER]: 'Title',
  [BLOCK_TYPES.TEXT]: 'TextFields',
  [BLOCK_TYPES.IMAGE]: 'Image',
  [BLOCK_TYPES.BUTTON]: 'SmartButton',
  [BLOCK_TYPES.CONTAINER]: 'ViewColumn',
  [BLOCK_TYPES.COLUMNCONTAINER]: 'ViewColumn',
  [BLOCK_TYPES.DIVIDER]: 'HorizontalRule',
  [BLOCK_TYPES.SPACER]: 'SpaceBar',
  [BLOCK_TYPES.COLUMN]: 'ViewColumn', // Icon for column block type
  [BLOCK_TYPES.HTMLCONTENT]: 'Code' // Icon for HTML content block type
};

// Block categories for organizing in toolbox
export const BLOCK_CATEGORIES = {
  CONTENT: 'content',
  LAYOUT: 'layout',
  BASIC: 'basic'
};

export const BLOCK_TYPE_CATEGORIES = {
  [BLOCK_TYPES.HEADER] : BLOCK_CATEGORIES.CONTENT,
  [BLOCK_TYPES.TEXT]: BLOCK_CATEGORIES.CONTENT,
  [BLOCK_TYPES.IMAGE]: BLOCK_CATEGORIES.CONTENT,
  [BLOCK_TYPES.BUTTON]: BLOCK_CATEGORIES.CONTENT,
  [BLOCK_TYPES.CONTAINER]: BLOCK_CATEGORIES.LAYOUT,
  [BLOCK_TYPES.COLUMNCONTAINER]: BLOCK_CATEGORIES.LAYOUT,
  [BLOCK_TYPES.DIVIDER]: BLOCK_CATEGORIES.BASIC,
  [BLOCK_TYPES.SPACER]: BLOCK_CATEGORIES.BASIC,
  [BLOCK_TYPES.COLUMN]: BLOCK_CATEGORIES.LAYOUT, // Category for column block type
  [BLOCK_TYPES.HTMLCONTENT]: BLOCK_CATEGORIES.CONTENT // Category for HTML content block type
};

// Blocks that can contain other blocks
export const CONTAINER_BLOCK_TYPES = [
  BLOCK_TYPES.CONTAINER,
  BLOCK_TYPES.COLUMNCONTAINER,
  BLOCK_TYPES.COLUMN // Container block type for columns
];

// Blocks that are self-closing/don't have content
export const SELF_CLOSING_BLOCK_TYPES = [
  BLOCK_TYPES.DIVIDER,
  BLOCK_TYPES.SPACER,
  BLOCK_TYPES.IMAGE
];

// Helper functions
export const isContainerBlock = (blockType) => {
  return CONTAINER_BLOCK_TYPES.includes(blockType);
};

export const isSelfClosingBlock = (blockType) => {
  return SELF_CLOSING_BLOCK_TYPES.includes(blockType);
};

export const getBlockTypeLabel = (blockType) => {
  return BLOCK_TYPE_LABELS[blockType] || blockType;
};

export const getBlockTypeDescription = (blockType) => {
  return BLOCK_TYPE_DESCRIPTIONS[blockType] || '';
};

export const getBlockTypeIcon = (blockType) => {
  return BLOCK_TYPE_ICONS[blockType] || 'Extension';
};

export const getBlocksByCategory = (category) => {
  return Object.keys(BLOCK_TYPE_CATEGORIES).filter(
    blockType => BLOCK_TYPE_CATEGORIES[blockType] === category
  );
};

export const getAllBlockTypes = () => {
  return Object.values(BLOCK_TYPES);
};